import { Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { StickerComponent } from '@atoms/sticker/sticker.component';

@Component({
  selector: 'app-car-detail-header-left',
  imports: [TranslateModule, StickerComponent],
  templateUrl: './car-detail-header-left.component.html',
  styleUrls: ['./car-detail-header-left.component.scss'],
})
export class CarDetailHeaderLeftComponent {
  @Input('in-stock') inStock?: boolean;
  @Input('branch-id') branchId?: number;
}
